import React from "react"

import { SmallH3Title } from "../../../styles/Commons/Titles"
import RenovationsIcon from "../../../Icons/RenovationsIcon"

const Renovations = () => {
  return (
    <div>
      <div className="icon-image">
        <RenovationsIcon />
      </div>
      <div className="icon-title">
        <SmallH3Title>Renovations</SmallH3Title>
      </div>
    </div>
  )
}

export default Renovations
